import { render, staticRenderFns } from "./img-text-block.vue?vue&type=template&id=3b80c50c&scoped=true&"
import script from "./img-text-block.vue?vue&type=script&lang=js&"
export * from "./img-text-block.vue?vue&type=script&lang=js&"
import style0 from "./img-text-block.vue?vue&type=style&index=0&id=3b80c50c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b80c50c",
  null
  
)

export default component.exports